import React, { useEffect, useState } from "react";
// react plugin used to create charts
import { Bar, Pie } from "react-chartjs-2";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Progress,
  Col,
  Input,
  FormGroup
} from "reactstrap";
import { getApi } from '../services/api'
import { APPLICATIONS_BY_DATE, DASHBOARD, LAST_APPLICATION, LAST_CAMP_DATA } from '../configs/urls'
import Loader from '../components/Loader'
import axios from 'axios';
import moment from 'moment';
import { ROLES_MAP, DASHBOARD_FILTERS, DATE_FORMATS, APPLICATION_STATUS, REPORT_DATE_TYPES } from '../configs/constant'
import { getLoggedInUserRole, getLoggedInUser } from '../services/localstorage'
import DatePicker from 'reactstrap-date-picker'

const Dashboard = () => {
  const [dashBoardData, setDashBoardData] = useState({});
  const [lastTenDaysApplicationData, setLastTenDaystApplicationData] = useState({});
  const [lastCampData, setLastCampData] = useState({ totalApplicationCount: {}, data: {} });
  const [lastCampDataSortBy, setLastCampDataSortBy] = useState(1);

  const [applciationByDateData, setApplciationByDateData] = useState({ totalApplicationCount: {}, data: {} });
  const [applciationByDateReqParams, setApplciationByDateReqParams] = useState({
    sort_by: 1,
    from_date: moment().subtract(1, 'month').toISOString(),
    to_date: moment().toISOString()
  });

  const [lastApplicationReqParams, setLastApplicationReqParams] = useState({
    selectedDateType: REPORT_DATE_TYPES.find((type) => type.id == 2),
    from_date: moment().subtract(1, 'month').toISOString(),
    to_date: moment().toISOString()
  });

  const [dashBoadFilterList, setDashBoadFilterList] = useState(DASHBOARD_FILTERS);

  const [isRequesting, setIsRequesting] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const userRole = getLoggedInUserRole();
  const loggedInUser = getLoggedInUser();

  useEffect(() => {
    setIsRequesting(true);
    const params = {};

    if (ROLES_MAP.department_officer == loggedInUser.role_id
      || ROLES_MAP.field_officer == loggedInUser.role_id) {
      params.department_id = loggedInUser.department_id
      const filterList = DASHBOARD_FILTERS.filter(val => val.slug == 'scheme_wise')
      setDashBoadFilterList(filterList)
    }

    if (ROLES_MAP.district_officer == loggedInUser.role_id
      || ROLES_MAP.dpm == loggedInUser.role_id
      || ROLES_MAP.field_officer == loggedInUser.role_id) {
      params.district_id = loggedInUser.district_id
    }

    if(ROLES_MAP.dpm == loggedInUser.role_id) {
      const filterList = DASHBOARD_FILTERS.filter(val => val.slug != 'district_wise')
      setDashBoadFilterList(filterList)
    }

    const dashboardData = getApi(DASHBOARD, params);
    const dashboardApplicationData = getApi(LAST_APPLICATION, { days: lastApplicationReqParams.selectedDateType.days, ...params });
    const lastCamp = getApi(LAST_CAMP_DATA, {sort_by: lastCampDataSortBy});

    const applicationByDate = getApi(APPLICATIONS_BY_DATE, {
      sort_by: applciationByDateReqParams.sort_by,
      from_date: moment(applciationByDateReqParams.from_date).format(DATE_FORMATS.DATE_SERVER_FORMAT),
      to_date: moment(applciationByDateReqParams.to_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
    });

    axios.all([dashboardData, dashboardApplicationData, lastCamp, applicationByDate]).then(res => {
      if (res[0].data) {
        setDashBoardData(res[0].data)
      }

      if (res[1].data) {
        lastApplicationDataSuccess(res[1].data)
      }

      if (res[2].data) {
        lastCampApplicationsSuccess(res[2].data)
      }

      if (res[3].data) {
        applicationByDateSuccess(res[3].data)
      }

    }).catch(err => {

    }).finally(() => {
      setIsRequesting(false);
    });
  }, []);

  const getRandomColor = () => {
    let color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
    return color;
  }

  const lastApplicationDataSuccess = (data) => {
    const applicationCount = data
    const applicationLast10DaysData = {
      labels: [
        APPLICATION_STATUS.ELIGBLE,
        APPLICATION_STATUS.PENDING_VERIFICATION,
        APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED,
        APPLICATION_STATUS.BENIFIT_GIVEN,
        APPLICATION_STATUS.NOT_ELIGBLE_REJECTED
      ],
      datasets: [{
        label: '# of Votes',
        data: [
          applicationCount.eligible,
          applicationCount.pending,
          applicationCount.not_eligible,
          applicationCount.benefit_given,
          applicationCount.reject
        ],
        backgroundColor: [
          '#007bff',
          '#fbc658',
          '#51bcda',
          '#6bd098',
          '#ef8157',
        ],
        borderColor: [
          '#007bff',
          '#fbc658',
          '#51bcda',
          '#6bd098',
          '#ef8157',
        ],
      }]
    };

    setLastTenDaystApplicationData(applicationLast10DaysData)
  }

  const getLastCampApplications = (sortBy) => {
    setIsLoading(true)
    getApi(LAST_CAMP_DATA, { sort_by: sortBy }).then(res => {
      lastCampApplicationsSuccess(res.data)
    }).catch(err => { }).finally(() => {
      setIsLoading(false);
    });
  }

  const getApplicationByDate = (sort_by, from_date, to_date) => {
    setIsLoading(true)
    const params = {
      sort_by,
      from_date: moment(from_date).format(DATE_FORMATS.DATE_SERVER_FORMAT),
      to_date: moment(to_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
    }
    getApi(APPLICATIONS_BY_DATE, params).then(res => {
      applicationByDateSuccess(res.data)
    }).catch(err => { }).finally(() => {
      setIsLoading(false);
    });
  }

  const lastCampApplicationsSuccess = (applications) => {
    const labels = []
    const countsData = []
    const colors = []

    applications.data.map(district => {
      labels.push(district.name)
      countsData.push(district.application_count)
      colors.push(getRandomColor())
    })

    const { benefit_given, eligible, pending, reject, not_eligible } = applications.totel_application_status_counts

    applications.totel_application_status_counts.total_count = benefit_given + eligible + pending + reject + not_eligible

    const lastCampDataToSet = {
      data: {
        labels,
        datasets: [
          {
            label: 'No. of applications',
            data: countsData,
            backgroundColor: colors,
            borderColor: colors,
          },
        ],
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'index',
          intersect: false
        },
        aspectRatio: 1,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [{
            ticks: {
              callback: function (value) {
                return value.substring(0, 20);
              },
            }
          }],
        },
      },
      totalApplicationCount: applications.totel_application_status_counts
    };

    setLastCampData(lastCampDataToSet)
  }

  const applicationByDateSuccess = (applications) => {
    const labels = []
    const countsData = []
    const colors = []

    applications.data.map(district => {
      labels.push(district.name)
      countsData.push(district.application_count)
      colors.push(getRandomColor())
    })

    const { benefit_given, eligible, pending, reject, not_eligible } = applications.totel_application_status_counts

    applications.totel_application_status_counts.total_count = benefit_given + eligible + pending + reject + not_eligible

    const applicationByDate = {
      data: {
        labels,
        datasets: [
          {
            label: 'No. of applications',
            data: countsData,
            backgroundColor: colors,
            borderColor: colors,
          },
        ],
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'index',
          intersect: false
        },
        aspectRatio: 1,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [{
            ticks: {
              callback: function (value) {
                return value.substring(0, 20);
              },
            }
          }],
        },
      },
      totalApplicationCount: applications.totel_application_status_counts
    };

    setApplciationByDateData(applicationByDate)
  }

  const setSelectedDateTypeAndGetData = (e) => {
    const selectedDateType = REPORT_DATE_TYPES.find((type) => type.id == e.target.value)
    setLastApplicationReqParams({...lastApplicationReqParams, selectedDateType: selectedDateType})
    if(selectedDateType.id == 4) return
    getLastDayApplicationData(selectedDateType.days)
  }

  const getLastDayApplicationData = (days) => {
    setIsLoading(true);
    const params = {};

    if (ROLES_MAP.department_officer == loggedInUser.role_id
      || ROLES_MAP.field_officer == loggedInUser.role_id) {
      params.department_id = loggedInUser.department_id
    }

    if (ROLES_MAP.district_officer == loggedInUser.role_id
      || ROLES_MAP.dpm == loggedInUser.role_id
      || ROLES_MAP.field_officer == loggedInUser.role_id) {
      params.district_id = loggedInUser.district_id
    }
    
    getApi(LAST_APPLICATION, { days: days, ...params }).then(res => {
      lastApplicationDataSuccess(res.data)
    }).catch(() => {}).finally(() => { setIsLoading(false) })
  }

  const renderDashboard = () => {
    return (
      <>
        <div className="content">
          <Row>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category">{APPLICATION_STATUS.TOTAL}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.total_count}</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category text-warning">{APPLICATION_STATUS.PENDING_VERIFICATION}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.pending}</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category text-primary">{APPLICATION_STATUS.ELIGBLE}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.eligible}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category text-info">{APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.not_eligible}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category text-success">{APPLICATION_STATUS.BENIFIT_GIVEN}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.benefit_given}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="3" md="6" sm="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col md="12" xs="7">
                      <div className="numbers">
                        <p className="card-category text-danger">{APPLICATION_STATUS.NOT_ELIGBLE_REJECTED}</p>
                        <CardTitle tag="p">{dashBoardData.application_status_counts.reject}</CardTitle>
                        <p />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h5">MGSVY APPLICATIONS STATISTICS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                    <Row>
                        <Col md={lastApplicationReqParams.selectedDateType.id == 4 ? '3' : '6'}>
                          <b>MGSVY Applications Wise Statistics</b>
                        </Col>
                        <Col md={lastApplicationReqParams.selectedDateType.id == 4 ? '3' : '6'}>
                          <FormGroup>
                            <label>Range</label>
                            <Input
                              type="select"
                              name="select-date-type"
                              value={lastApplicationReqParams.selectedDateType.id}
                              onChange={(e) => setSelectedDateTypeAndGetData(e)}
                            >
                              {
                                REPORT_DATE_TYPES.map(filter => (
                                  <option key={filter.id} value={filter.id}>{filter.label}</option>
                                ))
                              }
                            </Input>
                          </FormGroup>
                        </Col>
                        {
                          lastApplicationReqParams.selectedDateType.id == 4 &&
                          (
                            <>
                              <Col md="3">
                                <FormGroup>
                                  <label>From date</label>
                                  <DatePicker
                                    className="date-group"
                                    dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
                                    showClearButton={false}
                                    value={lastApplicationReqParams.from_date}
                                    onChange={(value, f) => {
                                      setLastApplicationReqParams({ ...lastApplicationReqParams, from_date: value })
                                      let days = moment(value).diff(moment(lastApplicationReqParams.to_date), 'days') // 1
                                      getLastDayApplicationData(days)
                                    }} />
                                </FormGroup>
                              </Col>
                              <Col md="3">
                                <FormGroup>
                                  <label>To date</label>
                                  <DatePicker
                                    className="date-group"
                                    showClearButton={false}
                                    dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
                                    value={lastApplicationReqParams.to_date}
                                    onChange={(value, f) => {
                                      setLastApplicationReqParams({ ...lastApplicationReqParams, to_date: value })
                                      let days = moment(lastApplicationReqParams.from_date).diff(moment(value), 'days') // 1
                                      getLastDayApplicationData(days)
                                    }} />
                                </FormGroup>
                              </Col>
                            </>
                          )
                        }
                      </Row>
                      <div className="mt-4">
                        <Pie data={lastTenDaysApplicationData} />
                      </div>
                    </Col>
                    <Col md="4">
                      <b>Application by Status</b>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE}</span>
                            <span>({`${dashBoardData.application_status_counts.eligible} / ${dashBoardData.application_status_counts.total_count}`})</span>
                          </div>
                          <Progress value={(dashBoardData.application_status_counts.eligible / dashBoardData.application_status_counts.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED}</span>
                            <span>({`${dashBoardData.application_status_counts.not_eligible} / ${dashBoardData.application_status_counts.total_count}`})</span>
                          </div>
                          <Progress color="info" value={(dashBoardData.application_status_counts.not_eligible / dashBoardData.application_status_counts.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.PENDING_VERIFICATION}</span>
                            <span>({`${dashBoardData.application_status_counts.pending} / ${dashBoardData.application_status_counts.total_count}`})</span>
                          </div>
                          <Progress color="warning" value={(dashBoardData.application_status_counts.pending / dashBoardData.application_status_counts.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.BENIFIT_GIVEN}</span>
                            <span>({`${dashBoardData.application_status_counts.benefit_given} / ${dashBoardData.application_status_counts.total_count}`})</span>
                          </div>
                          <Progress color="success" value={(dashBoardData.application_status_counts.benefit_given / dashBoardData.application_status_counts.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.NOT_ELIGBLE_REJECTED}</span>
                            <span>({`${dashBoardData.application_status_counts.reject} / ${dashBoardData.application_status_counts.total_count}`})</span>
                          </div>
                          <Progress color="danger" value={(dashBoardData.application_status_counts.reject / dashBoardData.application_status_counts.total_count) * 100} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h5">CAMP WISE STATISTICS</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <Row>
                        <Col md="6">
                          <b>Last camp application status</b>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Input
                              type="select"
                              name="status"
                              value={lastCampDataSortBy}
                              onChange={(e) => {
                                setLastCampDataSortBy(e.target.value)
                                getLastCampApplications(e.target.value)
                              }}
                            >
                              {
                                dashBoadFilterList.map(filter => (
                                  <option key={filter.id} value={filter.id}>{filter.label}</option>
                                ))
                              }
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="mt-4 over-flow-scroll">
                        <Bar width={2000} height={333} data={lastCampData.data} options={lastCampData.options} />
                      </div>
                    </Col>
                    <Col md="4">
                      <b>Last camp total applications</b>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE}</span>
                            <span>({`${lastCampData.totalApplicationCount.eligible} / ${lastCampData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress value={(lastCampData.totalApplicationCount.eligible / lastCampData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED}</span>
                            <span>({`${lastCampData.totalApplicationCount.not_eligible} / ${lastCampData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="info" value={(lastCampData.totalApplicationCount.not_eligible / lastCampData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.PENDING_VERIFICATION}</span>
                            <span>({`${lastCampData.totalApplicationCount.pending} / ${lastCampData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="warning" value={(lastCampData.totalApplicationCount.pending / lastCampData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.BENIFIT_GIVEN}</span>
                            <span>({`${lastCampData.totalApplicationCount.benefit_given} / ${lastCampData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="success" value={(lastCampData.totalApplicationCount.benefit_given / lastCampData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.NOT_ELIGBLE_REJECTED}</span>
                            <span>({`${lastCampData.totalApplicationCount.reject} / ${lastCampData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="danger" value={(lastCampData.totalApplicationCount.reject / lastCampData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h5">Total applications</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <Row>
                        <Col md="3">
                          <b>Total applications</b>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <label>Type</label>
                            <Input
                              type="select"
                              name="status"
                              value={applciationByDateReqParams.sort_by}
                              onChange={(e) => {
                                setApplciationByDateReqParams({ ...applciationByDateReqParams, sort_by: e.target.value })
                                getApplicationByDate(e.target.value, applciationByDateReqParams.from_date, applciationByDateReqParams.to_date)
                              }}
                            >
                              {
                                dashBoadFilterList.map(filter => (
                                  <option key={filter.id} value={filter.id}>{filter.label}</option>
                                ))
                              }
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <label>From date</label>
                            <DatePicker
                              className="date-group"
                              dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
                              showClearButton={false}
                              value={applciationByDateReqParams.from_date}
                              onChange={(value, f) => {
                                setApplciationByDateReqParams({ ...applciationByDateReqParams, from_date: value })
                                getApplicationByDate(applciationByDateReqParams.sort_by, value, applciationByDateReqParams.to_date)
                              }} />
                          </FormGroup>
                        </Col>
                        <Col md="3">
                          <FormGroup>
                            <label>To date</label>
                            <DatePicker
                              className="date-group"
                              showClearButton={false}
                              dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
                              value={applciationByDateReqParams.to_date}
                              onChange={(value, f) => {
                                setApplciationByDateReqParams({ ...applciationByDateReqParams, to_date: value })
                                getApplicationByDate(applciationByDateReqParams.sort_by, applciationByDateReqParams.from_date, value)
                              }} />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="mt-4 over-flow-scroll">
                        <Bar width={2000} height={333} data={applciationByDateData.data} options={applciationByDateData.options} />
                      </div>
                    </Col>
                    <Col md="4">
                      <b>Total application by status</b>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE}</span>
                            <span>({`${applciationByDateData.totalApplicationCount.eligible} / ${applciationByDateData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress value={(applciationByDateData.totalApplicationCount.eligible / applciationByDateData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED}</span>
                            <span>({`${applciationByDateData.totalApplicationCount.not_eligible} / ${applciationByDateData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="info" value={(applciationByDateData.totalApplicationCount.not_eligible / applciationByDateData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.PENDING_VERIFICATION}</span>
                            <span>({`${applciationByDateData.totalApplicationCount.pending} / ${applciationByDateData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="warning" value={(applciationByDateData.totalApplicationCount.pending / applciationByDateData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.BENIFIT_GIVEN}</span>
                            <span>({`${applciationByDateData.totalApplicationCount.benefit_given} / ${applciationByDateData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="success" value={(applciationByDateData.totalApplicationCount.benefit_given / applciationByDateData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md="12">
                          <div className="text-center">
                            <span>{APPLICATION_STATUS.NOT_ELIGBLE_REJECTED}</span>
                            <span>({`${applciationByDateData.totalApplicationCount.reject} / ${applciationByDateData.totalApplicationCount.total_count}`})</span>
                          </div>
                          <Progress color="danger" value={(applciationByDateData.totalApplicationCount.reject / applciationByDateData.totalApplicationCount.total_count) * 100} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {
            (userRole.id == ROLES_MAP.super_admin
              || userRole.id == ROLES_MAP.administrator
              || userRole.id == ROLES_MAP.director) &&
            <Row className="mt-4">
              <Col md="12">
                <Card>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col md="2">
                        <Row>
                          <Col className="text-center" md="12">
                            <b>{dashBoardData.department_count}</b>
                          </Col>
                          <Col md="12" className="text-center">
                            <b>DEPARTMENTS</b>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="2">
                        <Row>
                          <Col className="text-center" md="12">
                            <b>{dashBoardData.schema_count}</b>
                          </Col>
                          <Col md="12" className="text-center">
                            <b>SCHEMES</b>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="2">
                        <Row>
                          <Col className="text-center" md="12">
                            <b>{dashBoardData.district_count}</b>
                          </Col>
                          <Col md="12" className="text-center">
                            <b>DISTRICTS</b>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="2">
                        <Row>
                          <Col className="text-center" md="12">
                            <b>{dashBoardData.block_count}</b>
                          </Col>
                          <Col md="12" className="text-center">
                            <b>BLOCKS</b>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="3">
                        <Row>
                          <Col className="text-center" md="12">
                            <b>{dashBoardData.gram_panchayat_count}</b>
                          </Col>
                          <Col md="12" className="text-center">
                            <b>GRAM PANCHAYATS</b>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }

          <Loader isLoading={isLoading} />
        </div>
      </>
    );
  }

  return (
    <>
      {
        isRequesting ? <div className="content"><Loader isLoading={isRequesting} /></div> : renderDashboard()
      }
    </>
  )
}

export default Dashboard;
